import React, { useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleLogin } = useContext(AuthContext);
  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (hasProcessedRef.current) {
      return;
    }
    hasProcessedRef.current = true;

    const run = async () => {
      const code = String(searchParams.get('code') || '').trim();
      const state = String(searchParams.get('state') || '').trim();

      if (!code) {
        navigate('/login?authError=missing_code', { replace: true });
        return;
      }

      if (!state) {
        navigate('/login?authError=missing_state', { replace: true });
        return;
      }

      try {
        const query = new URLSearchParams({
          code,
          state,
        });
        const res = await axios.get(`/api/auth/authentik/exchange-code?${query.toString()}`);
        const { token, session, M_ComCode, next } = res.data || {};

        if (!token) {
          navigate('/login?authError=missing_token', { replace: true });
          return;
        }

        handleLogin(token);

        if (M_ComCode) {
          sessionStorage.setItem('M_ComCode', String(M_ComCode));
        }

        if (session) {
          sessionStorage.setItem('session', String(session));
        } else {
          sessionStorage.removeItem('session');
        }

        const target = String(next || '/').trim();
        navigate(target || '/', { replace: true });
      } catch (err) {
        const errorMsg = err?.response?.data?.message || err?.message || 'callback_failed';
        console.error('[AUTH CALLBACK ERROR]', {
          status: err?.response?.status,
          data: err?.response?.data,
          message: err?.message,
        });
        navigate(`/login?authError=${encodeURIComponent(errorMsg)}`, { replace: true });
      }
    };

    run();
  }, [handleLogin, navigate, searchParams]);

  return (
    <div className="login-container">
      <div className="login-card shadow">
        <div className="login-logo-text">SSO 로그인 처리 중...</div>
      </div>
    </div>
  );
}

export default AuthCallback;
